var $2b6e161c9edcf319$exports = {};
document.addEventListener('DOMContentLoaded', ()=>{
    $2b6e161c9edcf319$var$initNavbar();
    $2b6e161c9edcf319$var$initMobileMenu();
    $2b6e161c9edcf319$var$initFAQ();
    $2b6e161c9edcf319$var$initScrollReveal();
    $2b6e161c9edcf319$var$initAppointmentForm();
    $2b6e161c9edcf319$var$initTreatmentsCarousel();
    $2b6e161c9edcf319$var$initTreatmentLightbox();
});
/* ==========================================================================
   NAVBAR BACKGROUND ON SCROLL
   ========================================================================== */ function $2b6e161c9edcf319$var$initNavbar() {
    const header = document.querySelector('.header');
    const handleScroll = ()=>{
        if (window.scrollY > 50) header.classList.add('scrolled');
        else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', handleScroll);
    // Initial check in case of page reload/restore scroll position
    handleScroll();
}
/* ==========================================================================
   MOBILE MENU DRAWER
   ========================================================================== */ function $2b6e161c9edcf319$var$initMobileMenu() {
    const menuBtn = document.querySelector('.mobile-menu-btn');
    const navMenu = document.querySelector('.nav-menu');
    const navLinks = document.querySelectorAll('.nav-link');
    const toggleMenu = ()=>{
        const isExpanded = menuBtn.classList.contains('active');
        menuBtn.classList.toggle('active');
        navMenu.classList.toggle('active');
        // Accessibility: Set aria-expanded
        menuBtn.setAttribute('aria-expanded', !isExpanded);
    };
    const closeMenu = ()=>{
        menuBtn.classList.remove('active');
        navMenu.classList.remove('active');
        menuBtn.setAttribute('aria-expanded', 'false');
    };
    menuBtn.addEventListener('click', toggleMenu);
    navLinks.forEach((link)=>{
        link.addEventListener('click', closeMenu);
    });
    // Close menu on click outside
    document.addEventListener('click', (e)=>{
        if (!navMenu.contains(e.target) && !menuBtn.contains(e.target) && navMenu.classList.contains('active')) closeMenu();
    });
    // Close menu on Escape key press
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && navMenu.classList.contains('active')) {
            closeMenu();
            menuBtn.focus();
        }
    });
}
/* ==========================================================================
   FAQ ACCORDION
   ========================================================================== */ function $2b6e161c9edcf319$var$initFAQ() {
    const faqButtons = document.querySelectorAll('.faq-question-btn');
    faqButtons.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const item = btn.closest('.faq-item');
            const answer = item.querySelector('.faq-answer');
            const isActive = item.classList.contains('is-open');
            // Close all other items (accordion behavior)
            document.querySelectorAll('.faq-item').forEach((otherItem)=>{
                if (otherItem !== item && otherItem.classList.contains('is-open')) {
                    otherItem.classList.remove('is-open');
                    otherItem.querySelector('.faq-answer').style.maxHeight = '0px';
                    otherItem.querySelector('.faq-question-btn').setAttribute('aria-expanded', 'false');
                }
            });
            // Toggle active class on current item
            item.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', !isActive);
            if (!isActive) // Scrollheight handles dynamic text sizing
            answer.style.maxHeight = answer.scrollHeight + 'px';
            else answer.style.maxHeight = '0px';
        });
    });
}
/* ==========================================================================
   SCROLL REVEAL (INTERSECTION OBSERVER)
   ========================================================================== */ function $2b6e161c9edcf319$var$initScrollReveal() {
    const revealElements = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
        const observerOptions = {
            root: null,
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px' // offset trigger point slightly
        };
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    // Unobserve once revealed to save performance
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);
        revealElements.forEach((el)=>observer.observe(el));
    } else // Fallback if IntersectionObserver is not supported
    revealElements.forEach((el)=>el.classList.add('active'));
}
/* ==========================================================================
   APPOINTMENT FORM INTERACTION
   ========================================================================== */ function $2b6e161c9edcf319$var$initAppointmentForm() {
    const form = document.getElementById('appointment-form');
    if (!form) return;
    const formContainer = document.querySelector('.appointment-form-container');
    const successOverlay = document.querySelector('.form-success-overlay');
    const errorAlert = document.getElementById('form-error-alert');
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        // Check HTML5 validity safely
        try {
            if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
                if (typeof form.reportValidity === 'function') form.reportValidity();
                return;
            }
        } catch (valErr) {
            console.warn('Form validation notice:', valErr);
        }
        if (errorAlert) errorAlert.style.display = 'none';
        // Resolve submit button safely
        const submitBtn = e.submitter || form.querySelector('button[type="submit"]') || form.querySelector('button') || form.querySelector('.btn-primary');
        // Enter submitting state
        if (submitBtn) {
            submitBtn.classList.add('submitting');
            submitBtn.disabled = true;
        }
        try {
            const formData = new FormData(form);
            const data = Object.fromEntries(formData.entries());
            // Prepare payload formatted for email receipt
            const payload = {
                Nombre: data.nombre || '',
                Telefono: data.telefono || '',
                Email: data.email || '',
                Clinica: data.clinica || 'No especificada',
                Fecha_Preferida: data.fecha || 'No especificada',
                Mensaje: data.mensaje || 'Sin mensaje adicional',
                _subject: `Nueva Solicitud de Cita: ${data.nombre || 'Paciente'} - Vides Dental`,
                _template: 'table',
                _captcha: 'false'
            };
            const response = await fetch('https://formsubmit.co/ajax/videsdental.clinicas@gmail.com', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                // Display success state
                if (successOverlay) {
                    successOverlay.style.display = 'flex';
                    if (formContainer) formContainer.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
                form.reset();
            } else throw new Error(`Error en el servidor: HTTP ${response.status}`);
        } catch (error) {
            console.error('Error enviando formulario de cita:', error);
            if (errorAlert) {
                errorAlert.style.display = 'block';
                errorAlert.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
            } else alert("Hubo un inconveniente al enviar su solicitud. Por favor, int\xe9ntelo de nuevo.");
        } finally{
            // Restore submit button state
            if (submitBtn) {
                submitBtn.classList.remove('submitting');
                submitBtn.disabled = false;
            }
        }
    });
}
/* ==========================================================================
   TREATMENTS SHOWCASE CAROUSEL
   ========================================================================== */ function $2b6e161c9edcf319$var$initTreatmentsCarousel() {
    const carousel = document.querySelector('.treatments-carousel');
    if (!carousel) return;
    const track = carousel.querySelector('.carousel-track');
    const slides = carousel.querySelectorAll('.carousel-slide');
    const prevBtn = carousel.querySelector('.carousel-control.prev');
    const nextBtn = carousel.querySelector('.carousel-control.next');
    const dots = carousel.querySelectorAll('.indicator-dot');
    const extraLinks = document.querySelectorAll('.service-extra-link');
    let currentIndex = 0;
    const totalSlides = slides.length;
    let autoplayTimer = null;
    const AUTOPLAY_INTERVAL = 6000;
    function updateCarousel(index) {
        if (index < 0) currentIndex = totalSlides - 1;
        else if (index >= totalSlides) currentIndex = 0;
        else currentIndex = index;
        // Move track smoothly
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        // Update active class on slides
        slides.forEach((slide, i)=>{
            const isActive = i === currentIndex;
            slide.classList.toggle('active', isActive);
            slide.setAttribute('aria-hidden', !isActive);
        });
        // Update dots
        dots.forEach((dot, i)=>{
            const isActive = i === currentIndex;
            dot.classList.toggle('active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
    }
    function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(()=>{
            updateCarousel(currentIndex + 1);
        }, AUTOPLAY_INTERVAL);
    }
    function stopAutoplay() {
        if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    }
    // Previous & Next controls
    if (prevBtn) prevBtn.addEventListener('click', ()=>{
        updateCarousel(currentIndex - 1);
        startAutoplay();
    });
    if (nextBtn) nextBtn.addEventListener('click', ()=>{
        updateCarousel(currentIndex + 1);
        startAutoplay();
    });
    // Dot clicks
    dots.forEach((dot)=>{
        dot.addEventListener('click', ()=>{
            const slideIndex = parseInt(dot.getAttribute('data-index'), 10);
            if (!isNaN(slideIndex)) {
                updateCarousel(slideIndex);
                startAutoplay();
            }
        });
    });
    // Direct links from Service Cards (Implantología & Prótesis)
    extraLinks.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            const targetSlide = parseInt(link.getAttribute('data-slide'), 10);
            if (!isNaN(targetSlide)) {
                updateCarousel(targetSlide);
                startAutoplay();
            }
        });
    });
    // Pause autoplay on mouse hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    // Touch Swipe Support for mobile devices
    let startX = 0;
    let currentX = 0;
    let isSwiping = false;
    carousel.addEventListener('touchstart', (e)=>{
        startX = e.touches[0].clientX;
        currentX = startX;
        isSwiping = true;
        stopAutoplay();
    }, {
        passive: true
    });
    carousel.addEventListener('touchmove', (e)=>{
        if (!isSwiping) return;
        currentX = e.touches[0].clientX;
    }, {
        passive: true
    });
    carousel.addEventListener('touchend', ()=>{
        if (!isSwiping) return;
        isSwiping = false;
        const diff = startX - currentX;
        if (Math.abs(diff) > 40) {
            if (diff > 0) updateCarousel(currentIndex + 1);
            else updateCarousel(currentIndex - 1);
        }
        startAutoplay();
    });
    // Start autoplay initially
    startAutoplay();
}
/* ==========================================================================
   TREATMENT LIGHTBOX MODAL
   ========================================================================== */ function $2b6e161c9edcf319$var$initTreatmentLightbox() {
    const lightbox = document.getElementById('treatment-lightbox');
    if (!lightbox) return;
    const lightboxImg = lightbox.querySelector('.lightbox-image');
    const lightboxTitle = lightbox.querySelector('.lightbox-title');
    const closeBtn = lightbox.querySelector('.lightbox-close-btn');
    const backdrop = lightbox.querySelector('.lightbox-backdrop');
    const zoomTriggers = document.querySelectorAll('.slide-media, .slide-zoom-btn, .slide-zoom-trigger');
    function openLightbox(imgSrc, titleText, altText) {
        lightboxImg.src = imgSrc;
        lightboxImg.alt = altText || titleText;
        if (lightboxTitle) lightboxTitle.textContent = titleText;
        lightbox.classList.add('active');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
    }
    function closeLightbox() {
        lightbox.classList.remove('active');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        setTimeout(()=>{
            lightboxImg.src = '';
        }, 300);
    }
    zoomTriggers.forEach((trigger)=>{
        trigger.addEventListener('click', (e)=>{
            // Ignore if clicking on CTA link or button other than zoom
            if (e.target.closest('a') || e.target.closest('button') && !e.target.closest('.slide-zoom-btn') && !e.target.closest('.slide-zoom-trigger')) return;
            const slide = trigger.closest('.carousel-slide');
            if (!slide) return;
            const img = slide.querySelector('.slide-img');
            const title = slide.querySelector('.slide-title');
            if (img && title) openLightbox(img.src, title.textContent, img.alt);
        });
    });
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (backdrop) backdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && lightbox.classList.contains('active')) closeLightbox();
    });
}


//# sourceMappingURL=videDentalWebPage.06d798b5.js.map
